import * as React from "react";

export function Sino(props) {
  return (
    <svg
      width={92}
      height={92}
      viewBox="0 0 92 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_23_725)">
        <rect
          x={18.9229}
          y={16}
          width={54.7287}
          height={54.7287}
          rx={27.3644}
          fill="#FAFAFA"
        />
      </g>
      <path
        d="M56.464 39.656v-1.082c0-5.943-4.641-10.76-10.367-10.76-5.726 0-10.367 4.817-10.367 10.76v1.082c0 1.299-.37 2.569-1.065 3.65l-1.7 2.648c-1.555 2.419-.368 5.707 2.334 6.472a39.593 39.593 0 0021.596 0c2.703-.765 3.889-4.053 2.335-6.472l-1.701-2.649a6.758 6.758 0 01-1.065-3.649z"
        stroke="#081533"
        strokeWidth={1.53578}
      />
      <path
        d="M39.185 53.927c1.006 2.684 3.72 4.608 6.912 4.608 3.191 0 5.906-1.923 6.912-4.608"
        stroke="#081533"
        strokeWidth={1.53578}
        strokeLinecap="round"
      />
      <defs>
        <filter
          id="filter0_d_23_725"
          x={0.898851}
          y={0.894866}
          width={90.7765}
          height={90.7765}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.91887} />
          <feGaussianBlur stdDeviation={9.012} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_23_725"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_23_725"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
